// extracted by mini-css-extract-plugin
export default {"logoContainer":"index_logoContainer__FrYcr","logo":"index_logo__NH4Mi"};